import type { FaireProductEntity } from "../../entity_types/product";

export const p_szbgp7f6vn: FaireProductEntity = {
  token: "p_szbgp7f6vn",
  type: "product",
  name: "Heath Maple Serving/ Cutting Board Long Pill (Ships from Uk)",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/e1849f50c683dc492c337f4c26d9e22c90b5cb0546faf381f210cf0bb544b838.jpeg",
  galleryImageUrls: [],
  priceDollars: 32,
  description:
    "Please note this product will be shipping from the London, UK warehouse.\n\nThe family of health boards has been designed with communal dining in mind.\n\nMade from Sustainably Sourced American Maple hardwood which is a superior material for chopping boards, holding up to cuts, and resisting moisture.\n\nThe brass handle is both practical and pleasing. The boards are a beautiful backdrop for serving food for any occasion or simply for chopping food in the kitchen.\n\nDimensions: 60x12x2cm\nPlease note the handle will add 9 cm to the length of the boards listed.",
  tags: [],
  msrpDollars: 64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:26.315Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
